export default __webpack_public_path__ + "static/media/security.191185dd.gif";